// extracted by mini-css-extract-plugin
export default {"button":"Button_button__l4gLQ","accent":"Button_accent__USLoT"};